// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".0ba6a91d37e857fbe25cc3dae6d350e8.js";
};